import { Reducer } from 'redux';
import { produce } from 'immer';

import { STORES_TYPES, StoreState } from './types';

export const INITIAL_STATE: StoreState = {
  storeList: [],
};

const reducer: Reducer<StoreState> = (
  state = INITIAL_STATE,
  action = { type: '', payload: {} },
) => {
  return produce(state, draft => {
    switch (action.type) {
      case STORES_TYPES.SET_DATA_STORELIST:
        draft.storeList = action.payload;
        break;
      default:
    }
  });
};

export default reducer;
